import React, { useEffect, useState } from "react";
import SearchCard from "components/Card/SearchCard";
import { ReactComponent as BookmarkIcon } from "assets/icons/bookmark.svg";
import PropertyCardSkeleton from "components/Skeleton/PropertyCardSkeleton";
import { useOrganiseList } from "context/OrganiseListContext";
import { useInView } from "react-intersection-observer";
import useProperties from "hooks/useProperties";
import AnimatedDialogLayout from "components/Dialog/AnimatedDialogLayout";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";

const DoubtAndDiscardedPropertiesPopup = () => {
  const {
    doubtProperties,
    discardedProperties,
    isLoadingDoubt,
    isLoadingDiscarded,
    fetchDoubtProperties,
    fetchDiscardedProperties,
  } = useProperties();
  const {
    isFetchingList,
    isDoubtPropertiesActive,
    isDiscardedPropertiesActive,
    setIsDoubtPropertiesActive,
    setIsDiscardedPropertiesActive,
  } = useOrganiseList();

  const [activeList, setActiveList] = useState(
    isDoubtPropertiesActive ? "doubts" : "discarded"
  );
  const isPopulateProperty = true; // Fetch list with populate property

  useEffect(() => {
    if (isDoubtPropertiesActive) {
      setActiveList("doubts");
      fetchDoubtProperties(isPopulateProperty);
    } else if (isDiscardedPropertiesActive) {
      setActiveList("discarded");
      fetchDiscardedProperties(isPopulateProperty);
    }
  }, [isDoubtPropertiesActive, isDiscardedPropertiesActive]);

  const getFilteredProperties = () => {
    let properties = [];
    if (activeList === "doubts") {
      properties = doubtProperties?.results || [];
    } else if (activeList === "discarded") {
      properties = discardedProperties?.results || [];
    }
    return properties;
  };

  const filteredProperties = getFilteredProperties();

  const { ref: lastElementRef, inView } = useInView({
    threshold: 1.0,
    triggerOnce: false,
    rootMargin: "0px 0px 300px 0px",
  });

  const handleClosePopup = () => {
    document.body.style.overflow = "auto";
    setIsDiscardedPropertiesActive(false);
    setIsDoubtPropertiesActive(false);
  };

  useEffect(() => {
    if (inView) {
      if (
        activeList === "doubts" &&
        doubtProperties?.pagination?.nextPage &&
        !isLoadingDoubt
      ) {
        fetchDoubtProperties(
          isPopulateProperty,
          doubtProperties?.pagination?.nextPage
        );
      } else if (
        activeList === "discarded" &&
        discardedProperties?.pagination?.nextPage &&
        !isLoadingDiscarded
      ) {
        fetchDiscardedProperties(
          isPopulateProperty,
          discardedProperties?.pagination?.nextPage
        );
      }
    }
  }, [inView, activeList]);

  return (
    <AnimatedDialogLayout
      isOpen={isDoubtPropertiesActive || isDiscardedPropertiesActive}
      onClose={handleClosePopup}
      styleDropdown={{
        height: "100%",
        maxWidth: 1550,
        width: "100%",
        paddingTop: 14,
      }}
    >
      <div className="h-full flex flex-col">
        <div className="flex my-1 items-center justify-end">
          <CloseIcon
            onClick={handleClosePopup}
            className="w-4 h-4 cursor-pointer"
          />
        </div>
        <div className="px-[18px] mt-4 pb-[22px] flex-grow lg:mt-0 grid gap-y-[22px]">
          {filteredProperties.length > 0
            ? filteredProperties.map((property, index) => {
                const updatedProperty = {
                  ...property.propertyId,
                  average_gross_yield: property?.averageGrossYield,
                };
                return (
                  <SearchCard
                    key={property._id}
                    property={updatedProperty}
                    lastPropertyRef={
                      index === filteredProperties.length - 1
                        ? lastElementRef
                        : null
                    }
                    isOrganisePage={true}
                  />
                );
              })
            : !(isFetchingList || isLoadingDoubt || isLoadingDiscarded) && (
                <div className="flex flex-col items-center justify-center">
                  <BookmarkIcon className="w-[300px] h-[297px] text-white stroke-[#4F6F8F]" />
                  <p className="text-[#4F6F8F] text-center font-semibold leading-[30px] text-[24px] mt-[20px]">
                    Nessuna proprietà trovata
                  </p>
                </div>
              )}
          {(isFetchingList || isLoadingDoubt || isLoadingDiscarded) && (
            <PropertyCardSkeleton />
          )}
        </div>
      </div>
    </AnimatedDialogLayout>
  );
};

export default DoubtAndDiscardedPropertiesPopup;
